/* eslint-disable */
export default {
  _are_you_sure_start_over: 'are_you_sure_start_over',
  _are_you_sure_you_want_to_quit: 'are_you_sure_you_want_to_quit',
  _billy_blueberry: 'billy_blueberry',
  _birthday_candle_counting: 'birthday_candle_counting',
  _carole_bakings: 'carole_bakings',
  _charlie_chocolate: 'charlie_chocolate',
  _click_on_the_candles: 'click_on_the_candles',
  _duncan_doughnut: 'duncan_doughnut',
  _eight: 'eight',
  _five: 'five',
  _four: 'four',
  _gabby_gumdrop: 'gabby_gumdrop',
  _gloria_glaze: 'gloria_glaze',
  _how_old_is: 'how_old_is',
  _incorrect_answer: 'incorrect_answer',
  _izzy_icing: 'izzy_icing',
  _jake_jellybean: 'jake_jellybean',
  _karen_caramel: 'karen_caramel',
  _kevin_candycandy: 'kevin_candycandy',
  _lilly_lollipop: 'lilly_lollipop',
  _mikey_mint: 'mikey_mint',
  _molly_macaron: 'molly_macaron',
  _nine: 'nine',
  _one: 'one',
  _petey_pastry: 'petey_pastry',
  _play_again_or_decorate_cake: 'play_again_or_decorate_cake',
  _rachel_raspberry: 'rachel_raspberry',
  _rainbow_reese: 'rainbow_reese',
  _sally_sugar: 'sally_sugar',
  _sammy_swirl: 'sammy_swirl',
  _seven: 'seven',
  _shelly_sherbert: 'shelly_sherbert',
  _six: 'six',
  _susie_sprinkles: 'susie_sprinkles',
  _ten: 'ten',
  _three: 'three',
  _two: 'two',
  _well_done: 'well_done',
}